module.exports = __webpack_public_path__ + "static/img/wz-banner.e433f79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wz-banner.png
// module id = Uxse
// module chunks = 1